import React, { useMemo } from 'react';
import { ModalDropdownItemTrigger } from '@atlassian/entry-point-modal-trigger/ModalDropdownItemTrigger';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { defineMessages, useIntl } from '@atlassian/jira-intl';
import { optInModalEntryPoint } from './optInModalEntryPoint.tsx';

const messages = defineMessages({
	menuItemLabel: {
		id: 'admin-pages-field-schemes.ui.legacy-cmp-project.action-menu-item.non-final',
		defaultMessage: 'Use a different scheme',
		description:
			'Label for new menu item in actions dropdown on legacy CMP Project Settings Fields page',
	},
});

type Props = {
	projectId: string;
	restoreFocusElement?: HTMLElement;
};
export const ActionMenuItem = (props: Props) => {
	const cloudId = useCloudId();
	const { formatMessage } = useIntl();
	const { projectId, restoreFocusElement } = props;

	const entrypointParams = useMemo(() => {
		return {
			cloudId,
			projectId,
		};
	}, [cloudId, projectId]);

	const entrypointProps = useMemo(() => {
		return {
			onClose: () => {
				if (restoreFocusElement) {
					// Give time for modal close animation to complete before focusing element
					// requestAnimationFrame() and requestIdleCallback() didn't seem to work here
					// so we fall back to the good old setTimeout().
					// This workaround will go away once we fully migrate the page to React.
					setTimeout(() => {
						restoreFocusElement.focus();
					}, 400);
				}
			},
			onSaveComplete: () => {
				// Since we're on a legacy page, we'll refresh the whole thing in order to
				// see the updated message on template which hides legacy controls.
				globalThis.window.location.reload();
			},
		};
	}, [restoreFocusElement]);

	// For some reason Modal does not seem to work when using it with `component={BasicLink}`
	// Due to this, we've kept it as a button
	return (
		<ModalDropdownItemTrigger
			entryPoint={optInModalEntryPoint}
			entryPointParams={entrypointParams}
			entryPointProps={entrypointProps}
		>
			{formatMessage(messages.menuItemLabel)}
		</ModalDropdownItemTrigger>
	);
};
